module.exports = "<svg id=\"d2415d7b-8bd5-48ff-b8dd-eac2d4497bbc\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 47\"><title>star</title><polygon points=\"25 38.97 9.53 47 12.53 30.02 0 17.97 17.29 15.47 25 0 32.71 15.47 50 17.97 37.47 30.02 40.47 47 25 38.97\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/star.svg
// module id = 587
// module chunks = 1